import styled from "styled-components";
import { CgEye } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import { Avatar, Grid, IconButton, Tooltip } from "@mui/material";

import pages from "../../../constants/pages";
import { Chip, Search } from "../../../components";
import MuiTable from "../../../components/MuiTable";
import { colors } from "../../css components/Style";
import SortBy from "./Filter";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.purple} !important;
  color: ${colors.purple} !important;
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors.purple} !important;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({
  dpList,
  setPage,
  setSearchKey,
  loading,
  sortList,
  sortBy,
  setSortBy,
  platformTenants,
}) {
  const navigate = useNavigate();
  let columns = [
    { name: "", label: "" },

    {
      name: "brand_name",
      label: "Brand Name",
    },

    {
      name: "platform_ids",
      label: "Platform Source",
    },

    {
      name: "connection_url",
      label: sortBy === "NODE" ? "Connection URL" : "API URL",
    },
    { name: "status", label: "Status" },

    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "") {
      return <Avatar src={row.brandDetails.logo} />;
    }

    if (col.name === "brand_name") {
      return row.brandDetails.brand_name;
    }

    if (col.name === "platform_ids") {
      return row.connectionDetails.platform_ids
        .map(
          (val) =>
            platformTenants.find((plat) => plat.platform_id === val)
              .platform_name
        )
        .join(", ");
    }

    if (col.name === "connection_url") {
      return row.connectionDetails.connection_url;
    }

    if (col.name === "status") {
      if (row.connectionDetails.status === "INACTIVE") {
        return (
          <Chip
            label={row.connectionDetails.status}
            background={colors.lightError}
            color={colors.error}
          />
        );
      }

      if (row.connectionDetails.status === "ACTIVE") {
        return (
          <Chip
            label={row.connectionDetails.status}
            background={colors.lightSuccess}
            color={colors.success}
          />
        );
      }
    }

    if (col.name === "action") {
      return (
        <div>
          <Tooltip title="View Brand">
            <Icon
              onClick={() =>
                navigate(
                  pages.dpOnBoardingDetails.route +
                    row.connectionDetails.connection_id +
                    "?brandID=" +
                    row?.connectionDetails?.brand_id
                )
              }
            >
              <CgEye style={{ height: "20px", width: "20px" }} />
            </Icon>
          </Tooltip>
        </div>
      );
    }

    return value;
  };

  return (
    <Grid container spacing={8}>
      <Grid size={12} />
      <Grid size={12}>
        <MuiTable
          loading={loading}
          components={[
            <ToolBar
              sortList={sortList}
              sortBy={sortBy}
              setPage={setPage}
              setSortBy={setSortBy}
              setSearchKey={setSearchKey}
            />,
          ]}
          columns={columns}
          renderCell={renderCell}
          data={dpList}
        />
      </Grid>
    </Grid>
  );
}

export function ToolBar({ setPage, setSearchKey, sortBy, setSortBy }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", gap: "10px" }}>
        <Search setPage={setPage} setSearchKey={setSearchKey} />
        <SortBy setPage={setPage} sortBy={sortBy} setSortBy={setSortBy} />
      </div>
    </div>
  );
}
